
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_4277_15821)"}},[_c('path',{attrs:{"d":"M10 5v2.5l3.333-3.333L10 .833v2.5A6.665 6.665 0 003.333 10a6.62 6.62 0 001.034 3.55l1.216-1.217A4.94 4.94 0 015 10c0-2.762 2.238-5 5-5zm5.633 1.45l-1.216 1.217A4.94 4.94 0 0115 10c0 2.762-2.238 5-5 5v-2.5l-3.333 3.333L10 19.167v-2.5A6.665 6.665 0 0016.667 10a6.62 6.62 0 00-1.034-3.55z","fill":"#58697D"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_4277_15821"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    